<template>
    <div class="mt-3 mt-md-0">
        <div class="mb-2" style="margin-top: -15px;">
            <a @click="goBack(false)">
                <font-awesome-icon icon="arrow-circle-left" class="mm-link" style="font-size: 1.5rem;"/>
            </a>
            <a @click="goBack(true)" class="ml-2">
                <font-awesome-icon icon="home" class="mm-link" style="font-size: 1.5rem;"/>
            </a>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'category'}"
                   @click="moveTo('category')">
                    Kategorie
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'description', disabled: isDisabled('description')}"
                   @click="moveTo('description')">
                    Beschreibung
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'foto', disabled: isDisabled('foto')}"
                   @click="moveTo('foto')">
                    Fotos
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'price', disabled: isDisabled('price')}"
                   @click="moveTo('price')">
                    Preis
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'location', disabled: isDisabled('location')}"
                   @click="moveTo('location')">
                    Standort
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'contact', disabled: isDisabled('contact')}"
                   @click="moveTo('contact')">
                    Kontakt
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link"
                   :class="{active: activeTab == 'impressum', disabled: isDisabled('impressum')}"
                   @click="moveTo('impressum')">
                    Impressum
                </a>
            </li>
        </ul>
        <div class="p-3 mt-3">
            <category-tab    v-if="activeTab == 'category'"    @nextTab="moveTo" :create="true"/>
            <description-tab v-if="activeTab == 'description'" @nextTab="moveTo" :create="true"/>
            <foto-tab        v-if="activeTab == 'foto'"        @nextTab="moveTo" @error="errorCreate" :create="true"/>
            <price-tab       v-if="activeTab == 'price'"       @nextTab="moveTo" :create="true"/>
            <location-tab    v-if="activeTab == 'location'"    @nextTab="moveTo" :create="true"/>
            <contact-tab     v-if="activeTab == 'contact'"     @nextTab="moveTo" :create="true"/>
            <impressum-tab   v-if="activeTab == 'impressum'"   @saveObject="saveObject" :create="true"/>
        </div>
        <loading v-if="loading"/>
        <b-modal ref="feedback-modal">
            <div class="d-block">
                <h5 v-if="success">{{success}}</h5>
                <h5 v-if="error">{{error}}</h5>
            </div>
            <template slot="modal-footer" slot-scope="{ cancel }">
                <!--<b-button variant="success" v-if="success" @click="goToMeineInserate">Meine Inserate</b-button>-->
                <!-- <b-button variant="danger" v-if="error" @click="startAgain">Neues Versuch</b-button> -->
                <b-button variant="secondary" v-if="error" @click="cancel">ok</b-button>
            </template>
        </b-modal>
        <b-toast id="error-toast" title="Fehlermeldung" variant="danger" solid>
            {{error}}
        </b-toast>
    </div>
</template>

<script>
import CategoryTab from '../../components/object/create/CategoryTab';
import DescriptionTab from '../../components/object/create/DescriptionTab';
import FotoTab from '../../components/object/create/FotoTab';
import PriceTab from '../../components/object/create/PriceTab';
import LocationTab from '../../components/object/create/LocationTab';
import ContactTab from '../../components/object/create/ContactTab';
import ImpressumTab from '../../components/object/create/ImpressumTab';
import Inserat from '../../classes/Inserat';

export default {
    name: 'inserat-create',
    data: () => {
        return {
            loading: false,
            success: '',
            error: '',
            activeTab: 'category',
            object_id : null
        }
    },
    components: {
        CategoryTab,
        DescriptionTab,
        FotoTab,
        PriceTab,
        LocationTab,
        ContactTab,
        ImpressumTab
    },
    methods: {
        errorCreate(error) {
            this.error     = error;
            this.$bvToast.show('error-toast');
        },
        moveTo(tab) {
            this.activeTab = tab;
        },
        isDisabled(tab) {
            if(localStorage.getItem('currentObject') !== null){
                let currentObject = Inserat.getObjectFromJSON(JSON.parse(localStorage.getItem('currentObject')));

                if(tab == 'description' && !currentObject.getCategoryId() ){
                    return true;
                }else if(tab == 'foto' && ! currentObject.getName() && ! currentObject.getDescription()){
                    return true;
                }else if(tab == 'price' && ! currentObject.isPriceTabAllowed() ){
                    return true;
                }else if(tab == 'location' && ! currentObject.getPriceAmount()){
                    return true;
                }else if(tab == 'contact' && ! currentObject.getLocation()){
                    return true;
                }else if(tab == 'impressum' && Object.keys(currentObject.getContact()).length == 0){
                    return true;
                }
                return false;
            }else {
                return true;
            }
        },
        prepareForm(inserat) {
            let form = new FormData();
            form.append('object', JSON.stringify(inserat));

            return form;
        },
        updateObjectID(){
              if(this.objects){
                this.object_id = this.objects[0].id;
              }
        },
        saveObject() {
            let inserat  = JSON.parse(localStorage.getItem('currentObject'));
            let form     = this.prepareForm(inserat);
            this.loading = true;

            this.$http.post('/objectApi/createObject', form).then(response => {
                this.error   = '';
                this.success = '';
                this.loading = false;

                if(response.status == 'success'){
                    let user = this.$store.state.user;
                    this.success = response.data;


                    if(!user.title || !user.phone) {
                        this.$store.dispatch('LOGIN_USER');
                    }

                    this.$store.dispatch('OBJECTS', this.$store.state.lastOpenedPage);
                    this.$store.dispatch('OVERVIEW');

                    if(user)
                    {
                      if(user.packet){
                        //this.$refs['feedback-modal'].show();
                        this.clearLocalStorage();
                        this.$router.push({name: 'inserat-uebersicht', params: {page: 1}});
                        setTimeout(()=>{
                          this.$bvToast.toast(this.success, {
                            variant: 'success'
                          },1000);
                        })

                      }
                      else
                      {
                        this.$http.get('objectApi/getLatestObject?user_id=' + user.id).then(response => {
                          let object_id = JSON.parse(response.data);
                          this.$router.push({name: 'inserat-booking', params: {object_id: object_id}});
                        }).catch(error => {
                          console.log(error);
                        })
                      }
                    }

                }else{
                    this.error = response.data;
                    this.$refs['feedback-modal'].show();
                }
            }).catch(error => {
                let response = error.response.data;

                this.loading = false;
                this.error   = response.data;
                this.$refs['feedback-modal'].show();
            });
        },
        clearLocalStorage() {
            localStorage.removeItem('currentObject');
            localStorage.removeItem('currentObjectTab');
            localStorage.removeItem('currentSelectedCategory');
        },
        startAgain() {
            this.clearLocalStorage();
            this.activeTab = 'category';
            this.error     = '';
        },
        goToMeineInserate() {
            this.clearLocalStorage();
            this.$refs['feedback-modal'].hide();
            this.$router.push({name: 'inserat-uebersicht', params: {page: 1}});
        },
        goBack(home = false){

            this.$bvModal.msgBoxConfirm('Ihr Inserat ist noch nicht gespeichert. Möchten Sie trotzdem die Seite verlassen?', {
                okVariant: 'danger',
                cancelTitle: 'Abbrechen',
                okTitle: 'Verlassen'
            }).then(val => {
                if(val){
                    this.clearLocalStorage();

                    if(home){
                        this.$router.push({name: 'inserat-uebersicht', params: {page: 1}});
                    } else {
                        this.$router.go(-1);
                    }
                }
            });
        }
    },
    created() {
        document.title = 'Neues Inserat erstellen';
        if(localStorage.getItem('currentObjectTab') !== null && localStorage.getItem('currentObject') !== null){
            this.activeTab = localStorage.getItem('currentObjectTab');
        }
    },
    beforeDestroy() {
        this.clearLocalStorage();
    },
}
</script>

<style scoped>
.nav-link{
    cursor: pointer;
}
.disabled.nav-link{
    cursor: not-allowed !important;
}
</style>
